import Vue from 'vue';
import Component from 'vue-class-component';


@Component({
props:{
name:{
    type:String,
    required:true
},
selected:{
  default:false
}
}
})
export default class Tab extends Vue{
selected:boolean;
name:String;

isActive:boolean=false;


get href(){
    return '#'+this.name.toLocaleLowerCase().replace(/ /g, '-');
   // return this.name.toLocaleLowerCase().replace(/ /g, '-');
}

mounted(){
    this.isActive = this.selected;
 }
}
